import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CreateTask from "@/pages/CreateTask";
import TaskDetail from "@/pages/TaskDetail";
import PublicBoard from "@/pages/PublicBoard";
import Report from "@/pages/Report";
import Users from "@/pages/Users";
import Assignees from "@/pages/Assignees";
import Todo from "@/pages/Todo";
import Profile from "@/pages/Profile";
import Trash from "@/pages/Trash";
import ResetPassword from "@/pages/ResetPassword";
import { RoutesList, NewRoute, RouteEditor, PublicRoute } from "@/pages/RoutesPages";
import RouteAnalytics from "@/pages/RouteAnalytics";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <p className="text-slate-500 text-sm">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/route/:token" element={<PublicRoute />} />
            <Route path="/routes" element={<Protected><RoutesList /></Protected>} />
            <Route path="/routes/analytics" element={<Protected><RouteAnalytics /></Protected>} />
            <Route path="/routes/new" element={<Protected><NewRoute /></Protected>} />
            <Route path="/routes/:id" element={<Protected><RouteEditor /></Protected>} />
            <Route path="/task/:token" element={<PublicBoard />} />
            <Route path="/board/:token" element={<PublicBoard />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/create" element={<Protected><CreateTask /></Protected>} />
            <Route path="/report" element={<Protected><Report /></Protected>} />
            <Route path="/admin/users" element={<Protected><Users /></Protected>} />
            <Route path="/assignees" element={<Protected><Assignees /></Protected>} />
            <Route path="/todo" element={<Protected><Todo /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/trash" element={<Protected><Trash /></Protected>} />
            <Route path="/tasks/:id" element={<Protected><TaskDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
